import { cn } from "@/lib/utils"

const Spinner = ({ className, large }: { className?: string; large?: boolean }) => (
  <div
    className={cn(
      "h-4 w-4 animate-spin select-none rounded-full border-2 border-black/10 border-t-brand-primary",
      large && "h-8 w-8 border-4",
      className,
    )}
  />
)

export default Spinner
